$(function () {
    $('.modal-close').on('click', function (e) {
        e.preventDefault();
        $.fancybox.close();
    })

    /*Mobile nav*/
    $('header .btn-menu').on('click', function (e) {
        e.preventDefault();
        $('.mobile-navbar').addClass('show');
        $('body').addClass('no-overflow');
    })
    $('header .icon-close').on('click', function (e) {
        e.preventDefault();
        $('.mobile-navbar').removeClass('show');
        $('body').removeClass('no-overflow');
    })
});
